export type SeoArticle = {
    id: string;
    path: string;
    title: string;
    listTitle: string;
    description: string;
};

export const seoArticles: SeoArticle[] = [
    {
        id: "coach-sportif-domicile-ile-de-france-avantages-benefices",
        path: "/article/coach-sportif-domicile-ile-de-france-avantages-benefices",
        title: "Coach sportif à domicile en Île-de-France : avantages",
        listTitle: "Coach sportif à domicile en Île-de-France : avantages et bénéfices",
        description: "Découvrez les avantages du coach sportif à domicile en Île-de-France : gain de temps, programme personnalisé, motivation et réduction fiscale."
    },
    {
        id: "coaching-sportif-domicile-avance-immediate-payer-moitie-prix",
        path: "/article/coaching-sportif-domicile-avance-immediate-payer-moitie-prix",
        title: "Coaching sportif à domicile avec avance immédiate",
        listTitle: "Coaching sportif à domicile avec avance immédiate : payez moitié prix",
        description: "Profitez de l'avance immédiate avec Hop La Coaching et payez seulement 50% de vos séances de coaching sportif à domicile."
    },
    {
        id: "coaching-sportif-personnalise-domicile-femmes-actives",
        path: "/article/coaching-sportif-personnalise-domicile-femmes-actives",
        title: "Coaching sportif personnalisé pour femmes actives",
        listTitle: "Coaching sportif personnalisé à domicile pour femmes actives",
        description: "Découvrez comment le coaching sportif personnalisé à domicile aide les femmes actives à atteindre leurs objectifs forme et bien-être."
    },
    {
        id: "tarifs-coach-sportif-domicile-ile-de-france",
        path: "/article/tarifs-coach-sportif-domicile-ile-de-france",
        title: "Tarifs d'un coach sportif à domicile en Île-de-France",
        listTitle: "Quels sont les tarifs d'un coach sportif à domicile en Île-de-France ?",
        description: "Comprenez les tarifs d'un coach sportif à domicile en Île-de-France et les avantages fiscaux disponibles avec Hop La Coaching."
    },
    {
        id: "perte-poids-coach-sportif-domicile-ile-de-france",
        path: "/article/perte-poids-coach-sportif-domicile-ile-de-france",
        title: "Perte de poids avec un coach sportif à domicile",
        listTitle: "Perte de poids avec un coach sportif à domicile en Île-de-France",
        description: "Atteignez vos objectifs de perte de poids avec un coach sportif à domicile en Île-de-France et un programme adapté à votre niveau."
    },
    {
        id: "coaching-bien-etre-remise-en-forme-domicile-seniors-ile-de-france",
        path: "/article/coaching-bien-etre-remise-en-forme-domicile-seniors-ile-de-france",
        title: "Coaching bien-être à domicile pour seniors",
        listTitle: "Coaching bien-être et remise en forme à domicile pour seniors en Île-de-France",
        description: "Améliorez mobilité, santé et bien-être avec un coaching sportif à domicile adapté aux seniors en Île-de-France."
    }
];

export function getSeoArticleByPath(path: string) {
    return seoArticles.find(article => article.path === path);
}

